// @flow @jsx h

import { h } from 'preact'
import style from './Byline.css'

type Props = {
  className?: string,
  persons: any[]
}

const Byline = (props: Props) => {
  const len = props.persons.length
  const className = `${style.byline}${
    props.className ? ` ${props.className}` : ''
  }`

  return (
    <div className={className}>
      Av{' '}
      {props.persons.map((person, idx) => {
        if (idx === len - 1) {
          return (
            <span key={String(idx)}>
              &amp;{' '}
              <span
                className={style.byline__name}
                dangerouslySetInnerHTML={{ __html: person.name }}
              />
            </span>
          )
        }

        if (idx === len - 2) {
          return (
            <span key={String(idx)}>
              <span
                className={style.byline__name}
                dangerouslySetInnerHTML={{ __html: person.name }}
              />{' '}
            </span>
          )
        }

        return (
          <span key={String(idx)}>
            <span
              className={style.byline__name}
              dangerouslySetInnerHTML={{ __html: person.name }}
            />,{' '}
          </span>
        )
      })}
    </div>
  )
}

export default Byline



// WEBPACK FOOTER //
// ./src/v1/components/Article/Header/Byline.js